import {LOCAL_STORAGE_ACCESS_TOKEN_KEY} from './api/authConstants';

export const isNullOrUndefined = value => value === undefined || value === null;

export const isNullOrUndefinedOrBlank = value =>
    value === undefined || value === null || `${value}`.trim().length === 0;

export const formatDate = (iso, includeTime = false) => {
    if (!iso) return '—';
    const opts = includeTime
        ?
        {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }
        :
        {year: 'numeric', month: 'short', day: 'numeric'};
    return new Intl.DateTimeFormat(undefined, opts).format(new Date(iso));
};

export const formatCurrency = (amount, currencyCode, compact = false) => {
    if (isNullOrUndefined(amount)) return '—';
    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            notation: compact ? 'compact' : undefined,
            currency: currencyCode || 'USD',
            currencyDisplay: 'narrowSymbol',
            minimumFractionDigits: compact ? 0 : 2,
            maximumFractionDigits: compact ? 1: 2,
            compactDisplay: compact ? 'short' : undefined,
        }).format(amount);
    } catch {
        return `${Number(amount).toFixed(2)} ${currencyCode ?? ''}`;
    }
};

export const formatNumber = (amount) => {
    return `${Number(amount).toFixed(2)}`;
};

export const findStyleByAmount = (amount) => {
    if (isNullOrUndefined(amount) ||
        !Number.isFinite(Number(amount))) return '';
    const n = Number(amount);
    if (n === 0) return 'zero-value';
    return n > 0 ? 'positive-value' : 'negative-value';
};

export function parseJwtFromToken(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        window.atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join(''),
    );
    return JSON.parse(jsonPayload);
}

export function isLoggedIn() {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    return accessToken && accessToken !== 'null' && accessToken !== 'undefined';
}

export const buildQueryParams = (params = []) => {
    const result = params
        .filter(p => p.key && !isNullOrUndefined(p.value))
        .map(p => `${p.key}=${p.value}`);
    return result.length === 0 ? '' : '?' + result.join('&');
};